import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Subscription } from 'rxjs';
import { CountrycurrencypageService } from '../countrycurrencypage.service';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-country-currency-feature',
  templateUrl: './country-currency-feature.component.html',
  imports: [ToHtmlPipe, CommonModule],
  // styleUrls: ['./country-currency-feature.component.scss']
})
export class CountryCurrencyFeatureComponent implements OnInit, OnDestroy {
  @Input() pageData: any;
  constructor(
    private contentful: ContentfulService,
    private countryCurrencyPageService: CountrycurrencypageService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  featureData: any;

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    const data = this.pageData?.features?.[0]?.fields;
    if (data != null) {
      this.featureData = {
        header: data?.title || '',
        paragraph: data?.content || '',
        image: {
          url: data?.image?.[0]?.fields?.file?.url || '',
          alt: data?.image?.[0]?.fields?.title || '',
        },
        image2: {
          url: data?.image?.[1]?.fields?.file?.url || '',
          alt: data?.image?.[1]?.fields?.title || '',
        },
      };
    }
  }
}
